const CoupleHero = () => {
  return (
    <div className="relative w-full h-full mt-16">
      <picture>
        {/* Only load this source on desktop screens (over 1024px) */}
        <source
          media="(min-width: 1024px)"
          srcSet="/hero/Desk/Couple.png"
          sizes="(min-width: 1500px) 1500px, 100vw"
        />
        {/* Fallback image */}
        <img
          className="w-full h-full object-cover hidden md:block"
          src="/hero/desk/Couple.png"
          alt="Holidays"
        />
        <img
          className="w-full h-full object-cover md:hidden"
          src="/hero/Mob/Couple.png"
          alt="Holidays"
        />
      </picture>

      {/* Overlay h1 text */}
      <h1 className="absolute uppercase text-2xl p-4 md:p-0 md:text-5xl font-bold -mt-40 md:-mt-36 2xl:-mt-48 md:ml-48 text-white destination-h1 text-center left-1/2 transform -translate-x-1/2 md:left-auto md:translate-x-0">
      Couple Holidays
      </h1>
    </div>
  );
};

export default CoupleHero;
